export const countValue = (value) => {
  if (value == null || (typeof value === "string" && !value.trim()) || typeof value === "boolean") return null
  const number = Number(value)
  return Number.isFinite(number) && number >= 0 ? number : null
}

export function summarizeOrganizations(organizations) {
  const sum = (field) => {
    const values = organizations.map((org) => countValue(org.grpTmnlSummary?.[field]))
    return values.some((value) => value == null) ? null : values.reduce((total, value) => total + value, 0)
  }
  const terminals = sum("totTerminals")
  const groupCounts = organizations.map((org) => countValue(org.grpTmnlSummary?.totGroups))
  const withGroups = groupCounts.some((value) => value == null) ? null : groupCounts.filter((value) => value > 0).length
  const terminalCounts = organizations.map((org) => countValue(org.grpTmnlSummary?.totTerminals))
  const withTerminals = terminalCounts.some((value) => value == null) ? null : terminalCounts.filter((value) => value > 0).length
  return {
    organizations: organizations.length,
    groups: sum("totGroups"), terminals, withTerminals, withGroups,
    withoutGroups: withGroups == null ? null : organizations.length - withGroups,
    groupCoveragePercent: withGroups != null && organizations.length > 0 ? Math.round(withGroups / organizations.length * 100) : null,
    withVersion: organizations.filter((org) => String(org.grpTmnlSummary?.latestAppVersion ?? "").trim()).length,
  }
}

// Follow pagination so the overview never silently treats one page as the whole fleet.
export async function loadOrganizations(api, signal) {
  const rows = []
  const seen = new Set()
  for (let page = 1; page <= 100; page += 1) {
    const response = await api.get("/organizations", { signal, headers: {
      Action: "V_APPR_ORG", "Page-Number": page, "Page-Size": 100,
      "Sort-Column": "org_code", "Sort-Order": "asc",
    } })
    const data = response.data
    if (!Array.isArray(data?.dataList)) throw new Error("Organization data is unavailable.")
    const batch = data.dataList.filter(Boolean)
    for (const org of batch) {
      if (!org.orgCode || seen.has(org.orgCode)) throw new Error("The organization list could not be loaded completely.")
      seen.add(org.orgCode)
      rows.push(org)
    }
    const pages = countValue(data.totalPages)
    const total = countValue(data.total)
    if (pages > 0 ? page >= pages : total > 0 ? rows.length >= total : batch.length < 100) {
      if (total > 0 && rows.length !== total) throw new Error("The organization list could not be loaded completely.")
      return rows
    }
    if (!batch.length) throw new Error("The organization list could not be loaded completely.")
  }
  throw new Error("The organization list is too large to load completely. Open Organizations to view it.")
}
